// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b636e8e","553":"6424f9bf","977":"cc71321d"}[chunkId] + ".chunk.js";
};